import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import { Card } from 'components/UI';
import Loading from 'components/Loading';
import ReservationList from './ReservationList';
import { useStyles } from './Reservations.styled';
import { Box, Typography, Button } from '@material-ui/core';
import { ReservationsActions } from 'state/modules/reservations';

const ReservationsTableList = ({ history, type, customParams }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { loading, pagination, reservations } = useSelector((state) => state.reservations);

  const [params, setParams] = useState({
    page: 1,
    limit: 3,
    ...customParams,
  });

  const fetchReservations = useCallback(
    (params = {}) => {
      dispatch(ReservationsActions.fetchReservations(params));
    },
    [dispatch]
  );

  useEffect(() => {
    fetchReservations(params);
  }, [fetchReservations, params]);

  const handlePageChange = (e, page) => {
    const newParams = { page: page + 1, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  const viewAllReservations = () => {
    let params = '';
    if (type === 'vehicle') {
      params = customParams?.vehicle_id ? `?vehicle_id=${customParams?.vehicle_id}` : '';
    } else if (type === 'user') {
      params = customParams?.user_id ? `?user_id=${customParams?.user_id}` : '';
    }
    history.push(buildUrl(`/reservations${params}`));
  };

  const title = (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography color="textPrimary" component="span">
        <Box fontSize={14} fontWeight="fontWeightMedium" data-cy="reservation-title">
          {i18n.t('reservations.title')}
        </Box>
      </Typography>
      <Button
        type="button"
        variant="text"
        color="primary"
        data-cy="view-all-reservations"
        disableFocusRipple={true}
        className={classes.button}
        onClick={viewAllReservations}
      >
        {i18n.t('reservations.view_all')}
      </Button>
    </Box>
  );

  return (
    <Card title={title} headerActionType="vertical">
      {loading ? (
        <Box
          className={classes.loadingContainer}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Loading />
        </Box>
      ) : (
        <>
          <ReservationList
            params={params}
            pagination={pagination}
            reservations={reservations}
            handleChangePage={handlePageChange}
          />
        </>
      )}
    </Card>
  );
};

ReservationsTableList.propTypes = {
  history: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['vehicle', 'customer', 'user']).isRequired,
};

ReservationsTableList.defaultProps = {
  title: '',
  type: 'vehicle',
  isCustomer: false,
};

export default ReservationsTableList;
